var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.selectedRequirements.length > 0)?_c('div',{staticClass:"wheels-trip-requirements"},_vm._l((_setup.selectedRequirements),function(requirement){return _c('div',{key:requirement.key,staticClass:"wheels-trip-requirements__item",class:{
      'wheels-trip-requirements__item--full-width':
        requirement.key ===
        _setup.SpecialRequirementsTypeKey.VehicleNeededEntireTrip,
    }},[_c('div',{staticClass:"wheels-trip-requirements__content",class:{
        'wheels-trip-requirements__content--modified': requirement.modified,
      }},[_c('WheelsSvgIcon',{staticClass:"wheels-trip-requirements__icon",attrs:{"icon":requirement.icon,"size":20}}),_c('span',[_vm._v(_vm._s(requirement.title))])],1)])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }